import React from "react";
import Icon from "@ant-design/icons";

const EditPenOnPaperRightHandSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
	stroke = "#667085",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill={fill}
	>
		<path
			d="M9.83598 2.61722L10.8204 1.63285C11.2475 1.20572 11.94 1.20572 12.3671 1.63285C12.7943 2.05999 12.7943 2.75251 12.3671 3.17965L6.17294 9.37386C5.86455 9.68225 5.48417 9.90895 5.06619 10.0335L3.5 10.5L3.96654 8.93382C4.09105 8.51584 4.31774 8.13546 4.62614 7.82707L9.83598 2.61722ZM9.83598 2.61722L11.375 4.15625M10.5 8.16666V10.9375C10.5 11.6624 9.91237 12.25 9.1875 12.25H3.0625C2.33763 12.25 1.75 11.6624 1.75 10.9375V4.8125C1.75 4.08762 2.33763 3.5 3.0625 3.5H5.83333"
			stroke={stroke}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
const EditPenOnPaperRightHandIcon = (props) => (
	<Icon component={() => <EditPenOnPaperRightHandSvg {...props} />} />
);

export default EditPenOnPaperRightHandIcon;
